// App Types and Default Configurations

export const APP_TYPES = {
  PITCH: 'pitch',
  MEETING: 'meeting',
  // Future apps can be added here
};

export const APP_DEFINITIONS = {
  [APP_TYPES.PITCH]: {
    type: APP_TYPES.PITCH,
    name: 'Submit Your Pitch',
    description: 'Allow founders to submit their startup pitch',
    icon: '📩',
    buttonText: 'Pitch to Me',
    defaultFields: [
      {
        id: 'company_name',
        type: 'text',
        label: 'Company Name',
        placeholder: 'e.g., Acme Inc.',
        required: true,
      },
      {
        id: 'one_liner',
        type: 'textarea',
        label: 'One-Liner',
        placeholder: 'Describe your company in one sentence',
        required: true,
      },
      {
        id: 'stage',
        type: 'dropdown',
        label: 'Stage',
        placeholder: 'Select your current stage',
        required: true,
        options: ['Idea', 'Pre-seed', 'Seed', 'Series A', 'Series B', 'Series C+'],
      },
      {
        id: 'business_model',
        type: 'dropdown',
        label: 'Core Business Model',
        placeholder: 'Select your business model',
        required: true,
        options: ['B2B SaaS', 'B2C Subscription', 'Marketplace', 'E-commerce', 'Ads/Media', 'Transaction Fee', 'Enterprise License', 'Freemium', 'Hardware', 'Other'],
      },
      {
        id: 'sector',
        type: 'dropdown',
        label: 'Sector',
        placeholder: 'Select your sector',
        required: false,
        options: ['AI/ML', 'Fintech', 'Healthcare', 'Climate Tech', 'Edtech', 'Consumer', 'Enterprise', 'Developer Tools', 'Security', 'Web3/Crypto', 'Other'],
      },
      {
        id: 'founder_linkedin',
        type: 'text',
        label: 'Founder LinkedIn',
        placeholder: 'https://linkedin.com/in/yourprofile',
        required: true,
      },
      {
        id: 'email',
        type: 'text',
        label: 'Email',
        placeholder: 'founder@company.com',
        required: true,
      },
      {
        id: 'pitch_deck',
        type: 'file',
        label: 'Pitch Deck',
        placeholder: 'Upload your deck',
        required: false,
      },
      {
        id: 'deck_url',
        type: 'text',
        label: 'Or Deck URL',
        placeholder: 'Link to your deck (Docsend, Google Drive, etc.)',
        required: false,
      },
      {
        id: 'additional_notes',
        type: 'textarea',
        label: 'Additional Notes',
        placeholder: 'Anything else you want to share?',
        required: false,
      },
    ],
  },
  [APP_TYPES.MEETING]: {
    type: APP_TYPES.MEETING,
    name: 'Book a Meeting',
    description: 'Link your Calendly or Cal.com',
    icon: '📆',
    iconComponent: 'calendar', // Use calendar icon
    buttonText: 'Book a Meeting',
    color: 'blue', // Blue color scheme
    defaultFields: [], // No form fields - redirects to external calendar
  },
};

// Field type definitions for custom fields
export const FIELD_TYPES = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  DROPDOWN: 'dropdown',
  FILE: 'file',
  LABEL: 'label',
};

export const FIELD_TYPE_OPTIONS = [
  { value: FIELD_TYPES.TEXT, label: 'Text Input', icon: '📝' },
  { value: FIELD_TYPES.TEXTAREA, label: 'Long Text', icon: '📄' },
  { value: FIELD_TYPES.DROPDOWN, label: 'Dropdown', icon: '📋' },
  { value: FIELD_TYPES.FILE, label: 'File Upload', icon: '📎' },
  { value: FIELD_TYPES.LABEL, label: 'Label/Header', icon: '🏷️' },
];
